import {useCallback, useMemo} from 'react';
import {
  ModalWrapper,
  CloseButtonWrapper,
  ModalContentWrapper
} from '../../../../../../../elements/v2/modals/Modals.styled';
import { InputWrapper, Subtitle, ActivationScheduleWrapper, ModalActionsWrapper, ModalBoxGray } from '../../../../components/NewConversationModal/NewConversationModal.styled';
import { observer } from 'mobx-react';
import dayjs from 'dayjs';
import TextArea from '../../../../../../../elements/v2/TextArea/TextArea';
import InputText from '../../../../../../../elements/v2/TextInput/TextInput';
import { useStore } from '../../../../../../../hooks';
import { IconButton, RoundedButton } from '../../../../../../../elements';
import DateTimePicker from '../../../../../../../elements/v2/DateTimePicker/DateTimePicker';

const EditMarketingModal = observer(() => {
  const { marketingStore } = useStore();
  const { modal } = marketingStore;

  const handleEndDateChange = useCallback((value) => {
    const startDate = marketingStore.currentCampaign.startDate;
    
    if (startDate && startDate.isSame(value, 'day')) {
      const minEndDate = startDate.add(4, 'hour');
      marketingStore.onChangeAttributeCampaign('endDate', minEndDate);
    } else {
      marketingStore.onChangeAttributeCampaign('endDate', value);
    }
  }, [marketingStore]);
  
  const minEndDate = useMemo(() => {
    const startDate = marketingStore.currentCampaign.startDate;
    const endDate = marketingStore.currentCampaign.endDate;
    
    return startDate && endDate && startDate.isSame(endDate, 'day')
    ? startDate.add(4, 'hour')
    : null;
  }, [marketingStore.currentCampaign.startDate, marketingStore.currentCampaign.endDate]);

  return (
    <ModalWrapper $isOpen={modal.editMarketing} $zIndex={5}>
      <ModalBoxGray width="50%" height="auto">
        <CloseButtonWrapper>
          <IconButton icon="close" width="16px" height="16px" onClick={() => modal.onCancel("editMarketing")} dataTestId={"close-button"}/>
        </CloseButtonWrapper>
        <ModalContentWrapper>
          <InputWrapper>
            <Subtitle>Title</Subtitle>
            <InputText
              placeholder="Name"
              value={marketingStore.currentCampaign.name}
              onChange={(e) => marketingStore.onChangeAttributeCampaign("name", e.target.value)}
              displayError={marketingStore.validCampaignName}
              validationError={marketingStore.validCampaignName ? "Name cannot be empty. Please enter a valid name." : ""}
            />
          </InputWrapper>

          <InputWrapper>
            <Subtitle>Description</Subtitle>
            <TextArea
              placeholder="Enter a description"
              height="120px"
              resize="none"
              value={marketingStore.currentCampaign.description}
              onChange={e => marketingStore.onChangeAttributeCampaign("description", e.target.value)}
            />
          </InputWrapper>

          <InputWrapper>
            <Subtitle>Activation Schedule</Subtitle>
            <ActivationScheduleWrapper>
              <DateTimePicker
                label="Start Date"
                value={marketingStore.currentCampaign.startDate}
                onChange={value => marketingStore.onChangeAttributeCampaign("startDate", value)}
                minDate={dayjs()}
              />
              <DateTimePicker
                label="Start Time"
                value={marketingStore.currentCampaign.startDate}
                type="time"
                onChange={value => marketingStore.onChangeAttributeCampaign("startDate", value)}
              />
              <DateTimePicker
                label="End Date - optional"
                value={marketingStore.currentCampaign.endDate}
                onChange={handleEndDateChange}
                minDate={minEndDate}
              />
              <DateTimePicker
                label="End Time - optional"
                value={marketingStore.currentCampaign.endDate}
                type="time"
                onChange={handleEndDateChange}
                minTime={minEndDate}
              />
            </ActivationScheduleWrapper>
          </InputWrapper>
        </ModalContentWrapper>
        <ModalActionsWrapper>
          <RoundedButton onClick={() => modal.onConfirm("editMarketing")} width="115px">Save</RoundedButton>
        </ModalActionsWrapper>
      </ModalBoxGray>
    </ModalWrapper>
  );
});

export default EditMarketingModal;
